export default __webpack_public_path__ + "static/media/Single Homes.1884613f.svg";